<template>
  <mdicon
    class="ml-2 animate-spin"
    size="18"
    name="loading"
    aria-label="Loading"
  />
</template>
